import ChatIcon from '@atoms/ChatIcon';
import useFeatureFlag from '@customHooks/useFeatureFlag';
import { FEATURE_FLAGS } from '@root/constants';
import React from 'react';

const ChaBot: React.FC = () => {
  const [isFeatureAvailable] = useFeatureFlag({
    featureName: [FEATURE_FLAGS.CHAT_GPT],
  });

  if (isFeatureAvailable[FEATURE_FLAGS.CHAT_GPT]?.show) {
    return <ChatIcon />;
  }

  return null;
};

export default ChaBot;
